




















import Vue from "vue";

import IconLeft from "../../assets/icons/black/ChevronLeft.svg";
import IconRight from "../../assets/icons/black/ChevronRight.svg";
import IconCard from "../../assets/icons/default/Help.svg"; // not the correct one
import JzButton from "../control/JzButton.vue";
import JzInputDropdown from "../control/JzInputDropdown.vue";
import { FormOption } from "../../models/control";

interface Methods {
  goLeft: () => void;
  goRight: () => void;
  goToPage: (pageIndex: number) => void;
}

interface Computed {
  options: FormOption<number>[];
}

interface Props {
  currentIndex: number;
  icons: { [key: string]: string };
  msgLabel: string;
  msgSummary: string;
  questionsCount: number;
  summaryIndex: number;
}

export default Vue.extend<{}, Methods, Computed, Props>({
  name: "JzDrillBrowser",
  components: { JzButton, JzInputDropdown },

  props: {
    currentIndex: { type: Number, required: true },
    icons: {
      type: Object as () => { [key: string]: string },
      default: () => ({
        card: IconCard,
        left: IconLeft,
        right: IconRight
      })
    },
    msgLabel: { type: String, default: "" },
    msgSummary: { type: String, default: "" },
    questionsCount: { type: Number, required: true },
    summaryIndex: { type: Number, required: true }
  },

  computed: {
    options() {
      return [
        // Questions
        ...Array.from(new Array(this.questionsCount)).map((_, index) => ({
          label: `Q${index + 1}`,
          value: index
        })),
        // Summary
        { label: this.msgSummary, value: this.summaryIndex }
      ];
    }
  },

  methods: {
    goLeft() {
      const targetPage =
        this.currentIndex > 0 ? this.currentIndex - 1 : this.summaryIndex;
      this.goToPage(targetPage);
      this.$emit("go-left");
    },

    goRight() {
      const targetPage =
        this.currentIndex !== this.summaryIndex ? this.currentIndex + 1 : 0;
      this.goToPage(targetPage);
      this.$emit("go-right");
    },

    goToPage(pageIndex) {
      this.$emit("go-to-page", pageIndex);
    }
  }
});
